/* eslint-disable no-extend-native */
/* eslint-disable ts/method-signature-style */
export {}

declare global {
    interface Array<T> {
        updateAll(this: Array<T>, ...items: Array<T>): Array<T>

        updateBy(this: Array<T>, items: Array<T>): Array<T>
    }
}

Array.prototype.updateAll = function <T>(this: Array<T>, ...items: Array<T>): Array<T> {
    return this.splice(0, this.length, ...items)
}

Array.prototype.updateBy = function <T>(this: Array<T>, items: Array<T>): Array<T> {
    return this.splice(0, this.length, ...items)
}
